import React from 'react';

const TermsOfService = () => {
  return (
    <div className="w-full text-xl">
      <main className="pt-8 pb-16 lg:pt-16 lg:pb-24 bg-white dark:bg-gray-900 antialiased">
        <div className="flex justify-between">
          <article className="mx-auto w-full sm:max-w-4xl lg:max-w-5xl format format-sm sm:format-base lg:format-lg format-blue dark:format-invert">
            <header className="mb-4 lg:mb-6 not-format text-center">
              <h1 className="mb-4 text-3xl font-extrabold leading-tight text-gray-900 lg:mb-6 lg:text-4xl dark:text-white">
                TERMS OF SERVICE
              </h1>
            </header>
            <h2 className="my-8 text-3xl font-extrabold leading-tight text-gray-900 lg:mb-6 lg:text-4xl dark:text-white">
              Terms
            </h2>
            <p className="lead my-8 text-xl">
              By accessing this web site, you are agreeing to be bound by these web site Terms and Conditions of Use,
              all applicable laws and regulations, and agree that you are responsible for compliance with any applicable
              local laws. If you do not agree with any of these terms, you are prohibited from using or accessing this
              site. The materials contained in this web site are protected by applicable copyright and trade mark law.
            </p>

            <h2 className="my-8 text-3xl font-extrabold leading-tight text-gray-900 lg:mb-6 lg:text-4xl dark:text-white">
              Use of Service
            </h2>
            <h4 className=" text-2xl">
              When using our Service, you agree to comply with the following content guidelines:
            </h4>
            <div>
              <ul className=" ml-6">
                <li className="my-4 list-disc text-xl">
                  You may not post any content that is illegal, defamatory, or obscene.
                </li>
                <li className="my-4 list-disc text-xl">
                  You may not post any content that infringes on the intellectual property rights of others
                </li>
                <li className="my-4 list-disc text-xl">You may not post any content that is false or misleading.</li>
                <li className="my-4 list-disc text-xl">
                  You may not post any content that contains viruses or other harmful code.
                </li>
                <li className="my-4 list-disc text-xl">
                  You may not use the Service to send unsolicited commercial messages.
                </li>
                <li className="my-4 list-disc text-xl">You may not use the Service to harass or intimidate others.</li>
                <li className="my-4 list-disc text-xl">
                  You may not use the Service to collect personal information about others without their consent.
                </li>
                <li className="my-4 list-disc text-xl">You may not use the Service to impersonate others.</li>
                <li className="my-4 list-disc text-xl">
                  You may not use the Service to engage in any illegal activity.
                </li>
              </ul>
            </div>
            <div>
              <h2 className="my-8 text-3xl font-extrabold leading-tight text-gray-900 lg:mb-6 lg:text-4xl dark:text-white">
                Disclaimer
              </h2>
              <div className="text-xl my-4">
                The materials on Agal Software Solutions Limited web site are provided "as is". Agal Software Solutions
                Limited makes no warranties, expressed or implied, and hereby disclaims and negates all other
                warranties, including without limitation, implied warranties or conditions of merchantability, fitness
                for a particular purpose, or non-infringement of intellectual property or other violation of rights.
                Further, Agal Software Solutions Limited does not warrant or make any representations concerning the
                accuracy, likely results, or reliability of the use of the materials on its Internet web site or
                otherwise relating to such materials or on any sites linked to this site.
              </div>
            </div>

            <div>
              <div>
                <h2 className="my-8 text-3xl font-extrabold leading-tight text-gray-900 lg:mb-6 lg:text-4xl dark:text-white">
                  Limitations
                </h2>
                <p className="text-xl">
                  In no event shall Agal Software Solutions Limited or its suppliers be liable for any damages
                  (including, without limitation, damages for loss of data or profit, or due to business interruption,)
                  arising out of the use or inability to use the materials Agal Software Solutions Limited Internet
                  site, even if Agal Software Solutions authorized representative has been notified orally or in writing
                  of the possibility of such damage. Because some jurisdictions do not allow limitations on implied
                  warranties, or limitations of liability for consequential or incidental damages, these limitations may
                  not apply to you.
                </p>
              </div>
            </div>

            <div>
              <h2 className="my-8 text-3xl font-extrabold leading-tight text-gray-900 lg:mb-6 lg:text-4xl dark:text-white">
                Revisions and Errata
              </h2>
              <p className="text-xl">
                The materials appearing on Agal Software Solutions Limited web site could include technical,
                typographical, or photographic errors. Agal Software Solutions Limited not warrant that any of the
                materials on its web site are accurate, complete, or current. Agal Software Solutions Limited may make
                changes to the materials contained on its web site at any time without notice. Agal Software Solutions
                Limited does not, however, make any commitment to update the materials.
              </p>
            </div>

            <div>
              <h2 className="my-8 text-3xl font-extrabold leading-tight text-gray-900 lg:mb-6 lg:text-4xl dark:text-white">
                Site Terms of Use Modifications
              </h2>
              <p className="text-xl">
                Agal Software Solutions Limited may revise these terms of use for its web site at any time without
                notice. By using this website you are agreeing to be bound by the then current version of these Terms
                and Conditions of Use.
              </p>
            </div>

            <div>
              <h2 className="my-8 text-3xl font-extrabold leading-tight text-gray-900 lg:mb-6 lg:text-4xl dark:text-white">
                Governing Law
              </h2>
              <p className="text-lg">
                Any claim relating to Agal Software Solutions Limited web site shall be governed by the laws of the
                Country of Jamaica without regard to its conflict of law provisions. General Terms and Conditions
                applicable to Use of a Web Site. We are committed to conducting our business in accordance with these
                principles in order to ensure that the confidentiality of personal information is protected and
                maintained.
              </p>
            </div>
          </article>
        </div>
      </main>
    </div>
  );
};

export default TermsOfService;
